import axios from 'axios'
import { publicPath } from '../../vue.config'

export function snrMappings(serviceSlug) {
  return axios.get(publicPath + '/api/snr-mappings/' + serviceSlug)
}

export function stationMappings(stationSlug) {
  return axios.get(publicPath + '/api/station-mappings/' + stationSlug)
}
